import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { searchReturnTo } from '../components/searchReturnTo';
import { useAuth } from '../context/AuthContext';
import { CustomerDetailsNew } from '../modules/CustomerDetailsNew';

export const Route = createFileRoute('/customer-details/$customerId')({
  component: RouteComponent,
  params: z.object({
    customerId: z.coerce.number().positive(),
  }),
  validateSearch: z.object({
    tab: z.string().optional(),
    // Set when opened from a search on a phone; shows Back to that search.
    returnTo: searchReturnTo,
  }),
});

function RouteComponent() {
  const { customerId } = Route.useParams();
  const { tab, returnTo } = Route.useSearch();
  const { user } = useAuth();

  if (user.preferAdminView) {
    return <Navigate to="/customers/$customerId" params={{ customerId }} replace />;
  }

  return <CustomerDetailsNew customerId={customerId} initialTab={tab} returnTo={returnTo} />;
}
